import React from 'react';

import {
  Container,
  ItemButton,
  List,
  MenuAlign,
  TriggerWrap,
} from './styles';

export type MenuItem = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
};

export type MenuProps = {
  trigger: React.ReactNode;
  items: MenuItem[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  align?: MenuAlign;
  className?: string;
};

const Menu = ({
  trigger,
  items,
  open = false,
  onOpenChange,
  align = 'right',
  className,
}: MenuProps): JSX.Element => {
  const handleTriggerClick = (): void => {
    onOpenChange?.(!open);
  };

  const handleItemClick = (item: MenuItem): void => {
    if (item.disabled) return;
    item.onClick?.();
    onOpenChange?.(false);
  };

  return (
    <Container className={className}>
      <TriggerWrap onClick={handleTriggerClick} role="presentation">
        {trigger}
      </TriggerWrap>

      {open && (
        <List $align={align} role="menu">
          {items.map((item) => (
            <li key={item.id} role="none">
              <ItemButton
                type="button"
                role="menuitem"
                disabled={item.disabled}
                onClick={() => handleItemClick(item)}
              >
                {item.icon}
                {item.label}
              </ItemButton>
            </li>
          ))}
        </List>
      )}
    </Container>
  );
};

export default Menu;
